module.exports = __webpack_public_path__ + "static/media/slide-3.92742c70.png";